<mat-selection-list role="list" [multiple]="false">
  <mat-list-option role="listitem" routerLink="">Home</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/notice']">공지사항</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/product-plan']">생산계획 조회</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/product-mrp']">6개월예상 소요량조회</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/purchase']">발주서 조회/출력</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/packing-slip']">납품관리</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/invent-trans']">입고 내역</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/defect-management']">입고불량 발생 내역</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/defect-management/return']">공정불량/반품 내역</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/trade-performance']">거래 실적 조회</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/consigned-material/inventory']">사급품 재고현황</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/consigned-material/payment-statement']">사급품 수불명세서</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/consigned-material/transfer']">사급품 입출고 현황</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/consigned-material/common-model']">사급품 공용기종 현황</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/direct-delivery']">직송 입력</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/direct-delivery/confirm']">직송 확정 및 업로드</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/direct-delivery/status']">직송 현황</mat-list-option>
  <!--<mat-list-option role="listitem" [routerLink]="['/nonconformance/vendor']">수입검사 부적합 현황</mat-list-option>-->
  <!--<mat-list-option role="listitem" [routerLink]="['/nonconformance/product']">원인별 반품 현황</mat-list-option>-->
  <mat-list-option role="listitem" [routerLink]="['/4m']">4M 변경관리</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/trade-item']">거래 품목 조회</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/assembly']">Ass'y 별 사급품 현황</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/receipt-confirm']">입고확정관리</mat-list-option>
  <mat-list-option role="listitem" [routerLink]="['/tax-invoice']">세금계산서 금액집계</mat-list-option>

  <!-- Admin menu -->
  <div class="collapsible" id="adminArea">
    <mat-list-option role="listitem" (click)="expand('admin')">
      <div>
        <span>
          Admin
          <span class="toolbar-spacer"></span>
          <button mat-icon-button>
            <mat-icon>expand_more</mat-icon>
          </button>
        </span>
      </div>
    </mat-list-option>
    <div class="sub-menu">
      <mat-list-option class="content" name="admin" role="listitem" [routerLink]="['/admin/common-code']">&nbsp;공통코드</mat-list-option>
      <!--<mat-list-option class="content" name="admin" role="listitem"  [routerLink]="['/admin/program']">&nbsp;프로그램</mat-list-option>-->
      <mat-list-option class="content" name="admin" role="listitem" [routerLink]="['/admin/notice']">&nbsp;공지사항</mat-list-option>
      <mat-list-option class="content" name="admin" role="listitem" [routerLink]="['/admin/user']">&nbsp;사용자</mat-list-option>
      <!--<mat-list-option class="content" name="admin" role="listitem"  [routerLink]="['/admin/user/auth']">&nbsp;사용자 권한</mat-list-option>-->
      <mat-list-option class="content" name="admin" role="listitem" [routerLink]="['/admin/direct-delivery']">&nbsp;납품서 관리자</mat-list-option>
    </div>
  </div>
</mat-selection-list>
